// extracted by mini-css-extract-plugin
export default {"btnRelog":"styles-scoped__btnRelog--lls3L","titleModal":"styles-scoped__titleModal--sXsFJ"};